import {
  coordinate,
  InlineAlertFragment,
  money,
  offerBadge,
  tag,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const gqlQuery = gql`
  query UpsideOfferDetails(
    $merchantId: ID!
    $location: GeoCoordinateInput
    $category: String
  ) {
    myPartnerOffers {
      upsideOfferDetails(
        merchantId: $merchantId
        location: $location
        category: $category
      ) {
        id
        merchantId
        sourceMerchantId
        companionOfferId
        name
        title
        industry
        category
        shortDescription
        cashbackDescription
        cashbackAmount
        offerType
        offerSource
        status
        offerBracket
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        heroImage
        logoImage
        marker
        badge {
          ...offerBadge
        }
        tag {
          ...tag
        }
        addressText
        mapData {
          center {
            ...coordinate
          }
          markerLocation {
            ...coordinate
          }
          previewImage
        }
        pricingUnit
        pricingTiers {
          cashbackPerUnit
          originalPrice {
            ...money
          }
          tierDisplayName
          tierType
          disountedPrice {
            ...money
          }
        }
        cardUsageInfo {
          icon
          text
          trailingText
        }
        maxEarningsInfo {
          icon
          text
          trailingText
        }
        redemptionLocationInfo {
          icon
          text
          trailingText
        }
        singleUseInfo {
          icon
          text
          trailingText
        }
        primaryButton {
          id
          buttonStyle
          buttonText
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
              url
            }
            ... on ActivateOfferAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
        boost {
          id
          title
          body
          illustration
          iconV2
        }
        secondaryButton {
          id
          buttonStyle
          buttonText
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
              url
            }
            ... on DeactivateOfferAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
        disclosure
        disclosureTitle
        terms
        termsTitle
        legalUrl
        inLineAlerts {
          ...InlineAlertFragment
        }
        howItWorks {
          title
          steps
        }
      }
    }
  }
  ${offerBadge}
  ${tag}
  ${coordinate}
  ${money}
  ${AnalyticsEventFragment}
  ${InlineAlertFragment}
`;

export default gqlQuery;
